import { render, staticRenderFns } from "./ButtonPackingProduk.vue?vue&type=template&id=c6545eea&"
import script from "./ButtonPackingProduk.vue?vue&type=script&lang=js&"
export * from "./ButtonPackingProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports